import { wpInstance } from '../config';
import { ILocation } from '../types';

export const getLocations = async () => {
  try {
    const response = await wpInstance.get('/retrieve');

    const locations = response.data as ILocation[];

    return (
      locations
        ?.filter((loc) => loc.coordinates)
        .map((location) => {
          return {
            ...location,
            coordinates: {
              place_id: location.coordinates.place_id,
              lat: location.coordinates.lat,
              lng: location.coordinates.lng
            }
          };
        }) ?? []
    );
  } catch (err) {
    console.error('Error fetching locations:', err);
    return [];
  }
};
